export default {
    init() {
        const accordionSections = document.querySelectorAll(
            '.accordion-section'
        ) as NodeListOf<HTMLElement>;

        if (!accordionSections.length) return;

        accordionSections.forEach(function (accordionSection) {
            const accordionHeads = accordionSection.querySelectorAll(
                '[data-accordion-toggle]'
            );

            if (!accordionHeads) return;

            if (accordionHeads.length) {
                accordionHeads.forEach(function (accordionHead) {
                    accordionHead.addEventListener('click', function (event) {
                        event.stopPropagation();

                        const content =
                            accordionHead.nextElementSibling as HTMLElement;
                        const icon =
                            accordionHead.querySelector('.chevron-icon');

                        if (!content) return;

                        if (accordionHead.classList.contains('active')) {
                            accordionHead.setAttribute(
                                'aria-expanded',
                                'false'
                            );
                            icon?.classList.remove('rotate-0');
                            icon?.classList.add('rotate-180');
                            accordionHead.classList.remove('active');
                            content.setAttribute('style', 'maxHeight:0;');
                        } else {
                            accordionHead.classList.add('active');
                            accordionHead.setAttribute('aria-expanded', 'true');
                            icon?.classList.add('rotate-0');
                            icon?.classList.remove('rotate-180');
                            content.style.maxHeight =
                                content.scrollHeight + 'px';
                            content.style.height = 'auto';
                        }
                    });
                });
            }
        });
    }
};
